// App shell — auth-gated route dispatcher.

import { Loader2 } from "lucide-react";

import { Layout } from "./components/Layout";
import { Toast } from "./components/Toast";
import { StoreProvider, useStore } from "./lib/store";
import { AgentsPage } from "./pages/AgentsPage";
import { BillingPage } from "./pages/BillingPage";
import { BrandPage } from "./pages/BrandPage";
import { BriefingsPage } from "./pages/BriefingsPage";
import { CanvasPage } from "./pages/CanvasPage";
import { GraphBuilderPage } from "./pages/GraphBuilderPage";
import { HomePage } from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { SettingsPage } from "./pages/SettingsPage";
import { ThreadPage } from "./pages/ThreadPage";
import { TrainingPage } from "./pages/TrainingPage";

function RouteDispatcher() {
  const { route } = useStore();
  switch (route.name) {
    case "t":
      return <ThreadPage />;
    case "briefings":
      return <BriefingsPage />;
    case "agents":
      return <AgentsPage />;
    case "canvas":
      return <CanvasPage />;
    case "brand":
      return <BrandPage />;
    case "graph":
      return <GraphBuilderPage />;
    case "training":
      return <TrainingPage />;
    case "billing":
      return <BillingPage />;
    case "settings":
      return <SettingsPage />;
    case "home":
    default:
      return <HomePage />;
  }
}

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
    </div>
  );
}

function AuthGate() {
  const { authenticated } = useStore();
  if (authenticated === null) return <Splash />;
  if (authenticated === false) return <LoginPage />;
  return (
    <>
      <Layout>
        <RouteDispatcher />
      </Layout>
      <Toast />
    </>
  );
}

export function App() {
  return (
    <StoreProvider>
      <AuthGate />
    </StoreProvider>
  );
}
